// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2uhor","label":"LabeledBox_label__2-bJG"};